import React from "react"
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import CommonHeaderRight from "./CommonHeaderRight";
import CommonHeaderLeft from "./CommonHeaderLeft";


const DashboardHeader = () => {

	return (
		<Header>
			<HeaderLeft>
				{/* <CommonHeaderLeft /> */}
			</HeaderLeft>
			<CommonHeaderRight />
		</Header>
	);
};

export default DashboardHeader;
